// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"d485636b","123":"d485636b","328":"d485636b","334":"d485636b","336":"d485636b","340":"d485636b","580":"d485636b","640":"d485636b","717":"d485636b","923":"1dc05972"}[chunkId] + ".chunk.css";
};